import { createContext, useContext } from 'react'

const ProductDetailContext = createContext();

const useProductDetailContext = () => {
    // get the context
    const context = useContext(ProductDetailContext)
    // if `undefined`, throw an error
    if (!context === undefined) {
      throw new Error('useProductDetailContext was used outside of its Provider')
    }
  
    return context
  }

export { ProductDetailContext, useProductDetailContext }